import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcAnchoringupFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.884 11.385a1.25 1.25 0 0 1-1.768-1.769l6-6a1.25 1.25 0 0 1 1.768 0l6 6a1.25 1.25 0 0 1-1.768 1.769L12 6.269zm0 8.808a1.25 1.25 0 1 1-1.768-1.768l6-6a1.25 1.25 0 0 1 1.768 0l6 6a1.25 1.25 0 1 1-1.768 1.767L12 15.077z"
  }));
}
var IcAnchoringupFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcAnchoringupFill));

export { IcAnchoringupFill as I };
